<div class="modal-container">
  <div
    class="relative -ml-6 -mr-6 -mt-6 flex h-14 items-center justify-center gap-2 border-b border-b-grey-8"
  >
    <h2 class="py-4 font-bold">{{ message.sender }}</h2>
    <app-ui-icon-button
      (onClick)="closeDialog()"
      classes="absolute right-2 top-2"
      icon="close"
    ></app-ui-icon-button>
  </div>

  <div class="pt-4">
    <p class="text-lg font-bold">{{ message.title }}</p>
    <div [innerHTML]="message.body" class="prose"></div>
    <p class="text-right text-grey-6">{{ message.date }}</p>
  </div>
</div>
